<template>
  <div class="avatar-style-text">
    <span>name</span>
  </div>
</template>

<script>
export default {
  name: 'AvatarStyleText'
}
</script>

<style scoped lang="scss">
@import '@/assets/css/components';

.avatar-style-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;

  span {
    font-size: 1rem;
    text-transform: uppercase;
    color: $white;
    background: $tooltip-selector-color;
    transform: scale(.9) rotate(-5deg) translateY(40%);
    padding: .1rem .5rem;
  }
}
</style>
